"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "ButtonDelete", {
  enumerable: true,
  get: function get() {
    return _Button.ButtonDelete;
  }
});
Object.defineProperty(exports, "ButtonGroup", {
  enumerable: true,
  get: function get() {
    return _Button.ButtonGroup;
  }
});
Object.defineProperty(exports, "ButtonSave", {
  enumerable: true,
  get: function get() {
    return _Button.ButtonSave;
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});
Object.defineProperty(exports, "IconActive", {
  enumerable: true,
  get: function get() {
    return _Icon.IconActive;
  }
});
Object.defineProperty(exports, "IconDelete", {
  enumerable: true,
  get: function get() {
    return _Icon.IconDelete;
  }
});
Object.defineProperty(exports, "Infobar", {
  enumerable: true,
  get: function get() {
    return _Infobar.default;
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});
Object.defineProperty(exports, "ListBody", {
  enumerable: true,
  get: function get() {
    return _List.ListBody;
  }
});
Object.defineProperty(exports, "ListButton", {
  enumerable: true,
  get: function get() {
    return _List.ListButton;
  }
});
Object.defineProperty(exports, "ListContainer", {
  enumerable: true,
  get: function get() {
    return _List.ListContainer;
  }
});
Object.defineProperty(exports, "ListFoot", {
  enumerable: true,
  get: function get() {
    return _List.ListFoot;
  }
});
Object.defineProperty(exports, "ListHead", {
  enumerable: true,
  get: function get() {
    return _List.ListHead;
  }
});
Object.defineProperty(exports, "ListStack", {
  enumerable: true,
  get: function get() {
    return _List.ListStack;
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "PageScroll", {
  enumerable: true,
  get: function get() {
    return _PageScroll.default;
  }
});
Object.defineProperty(exports, "PageTitle", {
  enumerable: true,
  get: function get() {
    return _PageTitle.default;
  }
});
Object.defineProperty(exports, "Paging", {
  enumerable: true,
  get: function get() {
    return _Paging.default;
  }
});
exports.Ping = Ping;
Object.defineProperty(exports, "Tag", {
  enumerable: true,
  get: function get() {
    return _Icon.Tag;
  }
});
Object.defineProperty(exports, "Wait", {
  enumerable: true,
  get: function get() {
    return _Wait.default;
  }
});
Object.defineProperty(exports, "comparePaging", {
  enumerable: true,
  get: function get() {
    return _Paging.comparePaging;
  }
});
Object.defineProperty(exports, "createPaging", {
  enumerable: true,
  get: function get() {
    return _Paging.createPaging;
  }
});
var _List = _interopRequireWildcard(require("./List"));
var _Button = _interopRequireWildcard(require("./Button"));
var _Paging = _interopRequireWildcard(require("./Paging"));
var _Icon = _interopRequireWildcard(require("./Icon"));
var _Infobar = _interopRequireDefault(require("./Infobar"));
var _PageScroll = _interopRequireDefault(require("./PageScroll"));
var _PageTitle = _interopRequireDefault(require("./PageTitle"));
var _Modal = _interopRequireDefault(require("./Modal"));
var _Menu = _interopRequireDefault(require("./Menu"));
var _Wait = _interopRequireDefault(require("./Wait"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Ping(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-alert-dot', props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "_ping"
  }), /*#__PURE__*/React.createElement("div", {
    className: "_dot"
  }));
}